var StampIcon;
(function (StampIcon) {
    StampIcon["CANCELED"] = "canceled";
    StampIcon["CANCELED_OUTLINE"] = "canceled_outline";
    StampIcon["CHECK"] = "check";
    StampIcon["CLOCK"] = "waiting";
    StampIcon["LOCALE"] = "locale";
    StampIcon["NONE"] = "";
    StampIcon["WARNING"] = "warning";
})(StampIcon || (StampIcon = {}));
export { StampIcon, };
//# sourceMappingURL=stamp-constants.js.map